<template>
    <div>
        <b-form-group
                label="Search"
                label-for="search"
                :label-cols="3"
                :horizontal="false">
            <c-switch class="mx-1" color="success" variant="pill" v-model="constraints.table.search"/>
        </b-form-group>
       <b-form-group
            description="Records displayed per page"
            label="Per page"
            label-for="per_page"
            :label-cols="3"
            :horizontal="false">
            <b-form-input type="number" v-model.number="constraints.table.per_page"></b-form-input>
        </b-form-group>
    </div>
</template>
<script>
import { Switch as cSwitch } from '@coreui/vue'
import _ from 'lodash'

export default {
    components: {
        Fields: () => import("../../../base/Settings/Fields"),
        cSwitch
    },
    props: {
        value: {
            type: Object | String
        }
    },
    data: function() {
        return {}
    },
    computed: {
        constraints() {
            let constr = this.value

            if (constr.table.fields === null) {
                constr.table.fields = [];
            }

            return constr
        }
    },
    methods: {
        save() {
            this.$emit('input', this.constraints)
        },

        fieldError(error) {
        let found = this.errors.find((i, e) => {
            return i.field == error.field
        })

        if (found === undefined) {
            this.errors.push(error)
        } else {
            this.errors.map(e => {
                if (found.field == e.field)
                    e.error = error.error
            })
        }
        },

        checkForErrors() {
            return this.errors.find((i, e) => {
                return i.error
            })
        },

        validateFields() {
            return this.constraints.table.fields.find(f => {
                return this.field.field.key == f.key || this.field.field.label == f.label
            })
        }
    }
    
}
</script>